/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit User/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function User({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/InApp/Content/Outbound/User"
  
}) {
let inAppUserVaxiomPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'in_app',
path: 'user.vaxiom_person.first_name',
})
let inAppUserVaxiomPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'in_app',
path: 'user.vaxiom_person.last_name',
})
let aggregateData = fromAggregate.join(inAppUserVaxiomPersonFirstNameValueData, inAppUserVaxiomPersonLastNameValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 data="in_app.user.vaxiom_person.first_name"
 data="in_app.user.vaxiom_person.last_name"
 aggregate="/Data/aggregate.js join"
 maxWidth={120}
 marginRight={dtSpaceXs}
 text={aggregateData}
/>
{children}
</React.Fragment>)
}